import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Route-aware visibility for the Zoho SalesIQ launcher.
// The widget script is embedded once in public/index.html (loaded a single time
// in the SPA shell). This controller only toggles the launcher's visibility on
// route changes — it never inserts or removes the script, so no duplicates.
// The launcher is hidden on internal/staff pages (/admin/*) and shown elsewhere.
const isStaffPath = (pathname) => pathname.startsWith("/admin");

export const SalesIQController = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const hide = isStaffPath(pathname);
    let tries = 0;
    let interval;

    const apply = () => {
      const fb = window.$zoho?.salesiq?.floatbutton;
      if (fb && typeof fb.visible === "function") {
        fb.visible(hide ? "hide" : "show");
        return true;
      }
      return false;
    };

    // The widget loads async (defer). Retry until its API is ready (~10s max).
    if (!apply()) {
      interval = setInterval(() => {
        if (apply() || ++tries > 40) clearInterval(interval);
      }, 250);
    }

    return () => interval && clearInterval(interval);
  }, [pathname]);

  return null;
};
